import { render } from "./PersonalReport.vue?vue&type=template&id=480d80d5&scoped=true"
import script from "./PersonalReport.vue?vue&type=script&lang=js"
export * from "./PersonalReport.vue?vue&type=script&lang=js"

import "./PersonalReport.vue?vue&type=style&index=0&id=480d80d5&lang=less&scoped=true"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480d80d5"]])

export default __exports__